import axios from 'axios';
import BaseApi from '../BaseApi';
import { SendSoapType } from 'src/Types/Task/SenSoap';
import { TransitionCompleteResponse } from 'src/Types/Task';

export default class SendSoapAPI extends BaseApi {
	static getData = async (
		fileId: string,
		componentId: string,
	): Promise<SendSoapType> => {
		const url = `${window.host}/SendSoap/Task?fileId=${fileId}&componentId=${componentId}`;
		try {
			const request = await axios.get(url, { withCredentials: true });
			if (this.checkUnauthorized(request)) {
				throw new Error('Ошибка при получении данных задачи');
			} else {
				return request.data;
			}
		} catch (error: any) {
			throw new Error('Ошибка при получении данных задачи');
		}
	};

	static action = async (
		action: string,
		fileId: string,
		componentId: string,
		taskId: string,
	): Promise<TransitionCompleteResponse> => {
		const url = window.host + action;
		const body = { fileId, componentId, taskId };
		try {
			const request = await axios.post(url, body, {
				withCredentials: true,
			});
			if (this.checkUnauthorized(request)) {
				throw new Error(`Ошибка ${action}!`);
			} else {
				return request.data;
			}
		} catch (error: any) {
			throw new Error(`Ошибка ${action}!`);
		}
	};
}
